export const ZeroExLogo = ({
  className,
  classNameAnimation,
}: {
  className: string;
  classNameAnimation: string;
}) => (
  <svg
    className={className}
    width="414"
    height="418"
    viewBox="0 0 414 418"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.08" filter="url(#filter0_d_253_1109)" className={classNameAnimation}>
      <ellipse cx="207.024" cy="208" rx="140.977" ry="142" fill="#999999" />
      <path
        d="M347.5 208C347.5 286.152 284.603 349.5 207.024 349.5C129.444 349.5 66.5469 286.152 66.5469 208C66.5469 129.848 129.444 66.5 207.024 66.5C284.603 66.5 347.5 129.848 347.5 208Z"
        stroke="#5A5A5A"
      />
    </g>
    <g opacity="0.04" filter="url(#filter1_d_253_1109)" className={classNameAnimation}>
      <ellipse cx="207.023" cy="208" rx="203.523" ry="205" fill="#999999" />
      <path
        d="M410.046 208C410.046 320.946 319.146 412.5 207.023 412.5C94.8998 412.5 4 320.946 4 208C4 95.0544 94.8998 3.5 207.023 3.5C319.146 3.5 410.046 95.0544 410.046 208Z"
        stroke="#5A5A5A"
      />
    </g>
    <g opacity="0.12" filter="url(#filter2_d_253_1109)" className={classNameAnimation}>
      <ellipse cx="207.023" cy="208" rx="95.3082" ry="96" fill="#A6A6A6" />
      <path
        d="M301.831 208C301.831 260.747 259.381 303.5 207.023 303.5C154.665 303.5 112.215 260.747 112.215 208C112.215 155.253 154.665 112.5 207.023 112.5C259.381 112.5 301.831 155.253 301.831 208Z"
        stroke="#626262"
      />
    </g>
    <g id="interactive-group" className={classNameAnimation}>
      <rect x="146.773" y="147.68" width="120.974" height="120.974" rx="60.4872" fill="#26272B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M198.11 185.96C194.921 183.739 191.107 182.629 186.669 182.629C182.231 182.629 178.418 183.739 175.228 185.96C172.038 188.135 169.635 191.142 168.017 194.982C166.399 198.822 165.59 203.217 165.59 208.168C165.59 213.118 166.399 217.514 168.017 221.354C169.635 225.194 172.038 228.224 175.228 230.445C178.418 232.62 182.231 233.707 186.669 233.707C191.107 233.707 194.921 232.62 198.11 230.445C201.3 228.224 203.704 225.194 205.322 221.354C206.94 217.514 207.749 213.118 207.749 208.168C207.749 203.217 206.94 198.822 205.322 194.982C203.704 191.142 201.3 188.135 198.11 185.96ZM192.676 194.513C191.126 192.882 189.124 192.067 186.669 192.067C183.387 192.067 180.891 193.525 179.18 196.439C177.516 199.354 176.684 203.264 176.684 208.168C176.684 211.247 177.012 213.933 177.668 216.228L192.676 194.513ZM180.619 221.817C182.195 223.452 184.212 224.269 186.669 224.269C189.951 224.269 192.424 222.811 194.089 219.896C195.799 216.982 196.654 213.072 196.654 208.168C196.654 205.08 196.315 202.386 195.637 200.087L180.619 221.817Z"
        fill="white"
      />
      <path
        d="M220.914 213.442L207.878 232.597H220.36L226.462 221.77C226.924 221.03 227.201 220.058 227.294 218.855C227.34 218.393 227.432 218.046 227.571 217.814C227.71 217.537 227.987 217.398 228.403 217.398C229.05 217.398 229.42 217.814 229.513 218.647V218.855C229.605 220.058 229.882 221.03 230.345 221.77L236.447 232.597H248.928L235.892 213.442L247.818 195.954H235.337L230.345 205.045C229.79 206.017 229.513 206.988 229.513 207.96C229.513 208.376 229.42 208.723 229.235 209.001C229.097 209.278 228.819 209.417 228.403 209.417C227.987 209.417 227.687 209.278 227.502 209.001C227.363 208.723 227.294 208.376 227.294 207.96C227.294 206.988 227.016 206.017 226.462 205.045L221.469 195.954H208.988L220.914 213.442Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_253_1109"
        x="62.8036"
        y="63.8378"
        width="288.44"
        height="290.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_1109" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_253_1109"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_253_1109"
        x="0.256757"
        y="0.837838"
        width="413.532"
        height="416.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_1109" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_253_1109"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_253_1109"
        x="108.472"
        y="109.838"
        width="197.103"
        height="198.486"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.08108" />
        <feGaussianBlur stdDeviation="1.62162" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_1109" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_253_1109"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
